module.exports = __webpack_public_path__ + "static/media/b.e7ac6fb2.png";